
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masters-artificial-intelligence",
      function () {
        return require("private-next-pages/masters-artificial-intelligence/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masters-artificial-intelligence"])
      });
    }
  